module.exports = __webpack_public_path__ + "img/inner1-2.dbf1fa0f.png";